export default __webpack_public_path__ + "static/media/NoirPro-Bold.24429603.eot";